import { render } from "./PasswordChangeForm.vue?vue&type=template&id=6504815b"
import script from "./PasswordChangeForm.vue?vue&type=script&lang=js"
export * from "./PasswordChangeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__